// extracted by mini-css-extract-plugin
module.exports = {"root":"message-root-v9x","root_error":"message-root_error-sQZ message-root-v9x"};